export default {
    home: "Thuis",
    order: {
        submit: "Beoordelingsbestelling"
    },
    tunnel: {
        loginVerification: "Inlogverificatie",
        addressVerification: "Adresverificatie"
    },
    catalog: "Catalogus",
    all: "Alle",
    return: {
        return: "Opbrengst"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Bestelling namens",
    approvals: "Goedkeuringen",
    delegate: "Afgevaardigden",
    employees: "Mijn medewerkers",
}